<template>
  <!-- Search -->
  <div class="navigation-search__sidebar-search">
    <div class="input-group">
      <span class="input-group-text">
        <i class="bi bi-search"></i>
      </span>

      <input class="form-control text-white" placeholder="Search..." v-model="searchQuery" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalSearch } from '@/composable/globalSearch';

const { searchQuery } = useGlobalSearch();
</script>

<style lang="scss" scoped>
/* Search */
.navigation-search__sidebar-search {
  margin-bottom: 2rem;
}

.navigation-search__sidebar-search {
  .input-group {
    border-radius: 0.625rem;
    overflow: hidden;
  }

  .input-group-text {
    background: #252a34;
    border: none;
    color: #8f98ab;
  }

  .form-control {
    background: #252a34;
    border: none;
    padding: 0.75rem 1rem;
  }

  .form-control::placeholder {
    color: #80889b;
  }

  .form-control:focus {
    background: #2d3440;
    color: white;
    box-shadow: none;
  }
}
</style>
